export default __webpack_public_path__ + "static/media/total_crocs@2x.117ee4a8.png";